module.exports = __webpack_public_path__ + "static/img/money@2x.99fc5bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/money@2x.png
// module id = StUP
// module chunks = 1